(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfso-tiktok-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('perfso-tiktok-carousel')) {
    customElements.define('perfso-tiktok-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ptc__track');
        this.buttons = Array.from(this.querySelectorAll('[data-step]'));
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.onUpdate = () => this.updateButtons();
        this.track.addEventListener('scroll', this.onUpdate, { passive: true, signal });
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const first = this.cards[0];
          if (!first) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({
            left: (first.getBoundingClientRect().width + gap) * Number(button.dataset.step),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal }));
        this.cards.forEach(card => {
          const id = this.videoId(card.dataset.url);
          if (!id) {
            const cover = card.querySelector('[data-cover]');
            if (cover) cover.hidden = true;
            const warning = card.querySelector('[data-fallback]'); // only rendered inside the theme editor
            if (warning) warning.hidden = false;
            else card.hidden = true; // storefront: hide the card, keep the rest of the section
            return;
          }
          card.dataset.videoId = id;
          const cover = card.querySelector('[data-cover]');
          if (cover) cover.addEventListener('click', () => this.mount(card, true), { signal });
          else this.mount(card, false);
        });
        // Hidden (invalid) cards must not drive arrow state or scroll step.
        this.cards = this.cards.filter(card => !card.hidden);
        this.resizeObserver = new ResizeObserver(this.onUpdate);
        this.resizeObserver.observe(this.track);
        this.updateButtons();
      }
      videoId(value) {
        try {
          const text = String(value || '').trim();
          let url;
          try { url = new URL(text); } catch (_) { url = new URL('https://' + text); } // tolerate a missing https://
          const host = url.hostname;
          if (host !== 'tiktok.com' && !host.endsWith('.tiktok.com')) return null; // only the ID is used, never the pasted URL
          const match = url.pathname.match(/^\/(?:@|%40)[^/]+\/video\/(\d+)\/?$/);
          return match ? match[1] : null;
        } catch (_) { return null; }
      }
      mount(card, autoplay) {
        if (card.querySelector('iframe')) return;
        // Stop other active players: cover cards go back to their cover; cover-less players
        // get TikTok's documented host->player "pause" message (sending needs no listener).
        if (autoplay) this.cards.forEach(other => {
          if (other === card) return;
          const old = other.querySelector('iframe');
          if (!old) return;
          if (other.querySelector('[data-cover]')) {
            old.remove();
            other.querySelector('[data-cover]').hidden = false;
          } else {
            old.contentWindow?.postMessage({ type: 'pause', 'x-tiktok-player': true }, '*');
          }
        });
        const frame = document.createElement('iframe');
        frame.src = 'https://www.tiktok.com/player/v1/' + card.dataset.videoId + '?autoplay=' + (autoplay ? '1' : '0') + '&controls=1&description=0&music_info=0';
        frame.title = (this.track.getAttribute('aria-label') || 'TikTok') + ' ' + card.dataset.index;
        frame.loading = autoplay ? 'eager' : 'lazy';
        frame.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        card.querySelector('[data-media]').append(frame);
        const cover = card.querySelector('[data-cover]');
        if (cover) cover.hidden = true;
        if (autoplay) frame.focus();
      }
      updateButtons() {
        if (!this.track || !this.buttons.length) return;
        // Geometry-based boundaries support both LTR and RTL themes.
        const track = this.track.getBoundingClientRect();
        const first = this.cards[0]?.getBoundingClientRect();
        const last = this.cards[this.cards.length - 1]?.getBoundingClientRect();
        if (!first || !last) return;
        this.querySelector('.ptc__nav').hidden = this.cards.length < 2 || this.track.scrollWidth <= this.track.clientWidth + 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const leftDone = rtl ? last.left >= track.left - 4 : first.left >= track.left - 4;
        const rightDone = rtl ? first.right <= track.right + 4 : last.right <= track.right + 4;
        this.buttons[0].disabled = leftDone;
        this.buttons[1].disabled = rightDone;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
        this.querySelectorAll('iframe').forEach(frame => frame.remove());
        this.querySelectorAll('[data-cover]').forEach(cover => { cover.hidden = false; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
